import { useRef, useState } from 'react';
import Image from '../../Image';
import Copiar from '../images/copiar.png';

// eslint-disable-next-line @typescript-eslint/explicit-module-boundary-types
export default function Copy(): JSX.Element {
    const textUrlRef = useRef(null);
    const [copySuccess, setCopySuccess] = useState('');

    const handleCopy = () => {
        textUrlRef.current.select();
        document.execCommand('copy');
        setCopySuccess('Copiado!');
        setTimeout(function () {
            setCopySuccess('');
        }, 2000);
    };
    return (
        <>
            <div className="grid w-full md:w-1/2 mx-auto flex-none  text-center pt-5 my-4">
                <div className="flex  text-center text-2xl font-bold italic   justify-center content-center text-sm-rent ">
                    Copia y comparte con tus Amigos
                    <div onClick={handleCopy}>
                        <Image
                            className={'text-center cursor-pointer pl-4'}
                            src={Copiar}
                            alt={'Copiar'}
                            height={30}
                            width={30}
                            maxHeight={30}
                            maxWidth={30}
                        />
                    </div>
                </div>

                <div className="flex flex-col text-center text-base italic text-sm-rent  ">
                    <textarea
                        className="rounded-xl px-2 md:px-1 py-6 md:py-2 text-center m-4 md:m-2"
                        ref={textUrlRef}
                        value={window.location.href}
                        readOnly
                    />{' '}
                    {copySuccess}
                </div>
            </div>
        </>
    );
}
